export const env = {
  DEVELOP: 'develop',
  STAGING: 'staging',
  PRODUCTION: 'production',
};

export const STAGE = env.DEVELOP;